import script from "./HelpTextTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpTextTooltip.vue?vue&type=script&setup=true&lang=js"

import "./HelpTextTooltip.vue?vue&type=style&index=0&id=165c1f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165c1f58"]])

export default __exports__